var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        {
          class: [
            "gfu-grid__cell",
            {
              "gfu-1of3": _vm.conditionFulfilled,
              "gfu-2of3": !_vm.conditionFulfilled,
            },
          ],
          attrs: { "data-qa": `filtersbox-field:${_vm.displayName}` },
        },
        [
          _c("div", { staticClass: "gfu-grid gfu-grid--gutter-columns" }, [
            _c(
              "div",
              {
                class: [
                  "gfu-grid__cell",
                  {
                    "gfu-1of1": _vm.conditionFulfilled,
                    "gfu-1of2": !_vm.conditionFulfilled,
                  },
                ],
              },
              [
                _c("option-field", {
                  attrs: {
                    "display-name": _vm.displayName,
                    options: _vm.options,
                    small: true,
                    "show-placeholder": false,
                    "data-qa": `filtersbox-field:${_vm.displayName}`,
                  },
                  model: {
                    value: _vm.value[_vm.conditionName],
                    callback: function ($$v) {
                      _vm.$set(_vm.value, _vm.conditionName, $$v)
                    },
                    expression: "value[conditionName]",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.conditionFulfilled
              ? _c(
                  "div",
                  { staticClass: "gfu-grid__cell gfu-1of2 _mt-1" },
                  [
                    _c("field-label", {
                      staticClass: "gfu-field__label--gray _mt-1",
                      attrs: { text: "Range" },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "gfu-grid gfu-grid--gutter-columns" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "gfu-grid__cell gfu-6of12",
                            attrs: { "data-qa": "date-field:MinDate" },
                          },
                          [
                            _c("date-field", {
                              staticClass: "_ma-0",
                              attrs: {
                                "display-name": "Min date",
                                name: "minDate",
                                "show-label": false,
                                small: true,
                              },
                              model: {
                                value: _vm.value[_vm.minDateFieldName],
                                callback: function ($$v) {
                                  _vm.$set(_vm.value, _vm.minDateFieldName, $$v)
                                },
                                expression: "value[minDateFieldName]",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "gfu-divider gfu-divider--small" },
                          [_vm._v("to")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "gfu-grid__cell gfu-6of12",
                            attrs: { "data-qa": "date-field:MaxDate" },
                          },
                          [
                            _c("date-field", {
                              staticClass: "_ma-0",
                              attrs: {
                                "display-name": "Max date",
                                name: "maxDate",
                                "show-label": false,
                                small: true,
                              },
                              model: {
                                value: _vm.value[_vm.maxDateFieldName],
                                callback: function ($$v) {
                                  _vm.$set(_vm.value, _vm.maxDateFieldName, $$v)
                                },
                                expression: "value[maxDateFieldName]",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }